import React from 'react';
import { ArrowLeft, Info } from 'lucide-react';
import CustomDataGrid from '../../components/common/CustomDataGrid/CustomDataGrid';
import CustomChip from '../../components/common/CustomChip/index';
import { useNavigate } from 'react-router-dom';
const columns = [
  {
    field: 'leadName',
    headerName: 'Lead Name',
    width: '200px',
    renderCell: (row) => (
      <div className="flex items-center gap-2">
        {row.leadName}
        <Info className="w-4 h-4 text-gray-400" />
      </div>
    ),
  },
  {
    field: 'company',
    headerName: 'Company',
    width: '200px',
  },
  {
    field: 'productInterest',
    headerName: 'Product Interest',
    width: '200px',
  },
  {
    field: 'paymentStatus',
    headerName: 'Payment Status',
    width: '200px',
    renderCell: (row) => (
      <CustomChip
        label={row.paymentStatus}
        variant={
          row.paymentStatus === 'Paid'
            ? 'success'
            : row.paymentStatus === 'Partially Paid'
            ? 'warning'
            : 'error'
        }
        size="sm"
      />
    ),
  },
  {
    field: 'amount',
    headerName: 'Amount',
    width: '150px',
  },
];
const data = [
  {
    id: 1,
    leadName: 'Sidharth Malviya',
    company: 'ICICI',
    productInterest: 'Mutual Fund',
    paymentStatus: 'Partially Paid',
    amount: '₹ 5,000',
  },
  {
    id: 2,
    leadName: 'Arjun Sehgal',
    company: 'HDFC',
    productInterest: 'Life Term',
    paymentStatus: 'Not-Paid',
    amount: '₹ 5,000',
  },
  {
    id: 3,
    leadName: 'Virat Kumar',
    company: 'MAX',
    productInterest: 'Car Insurance',
    paymentStatus: 'Paid',
    amount: '₹ 5,000',
  },
  {
    id: 4,
    leadName: 'Vikas Mahatre',
    company: 'Aditya Birla',
    productInterest: 'Fixed Deposit',
    paymentStatus: 'Paid',
    amount: '₹ 5,000',
  },
  {
    id: 5,
    leadName: 'Sidharth Malviya',
    company: 'HDFC',
    productInterest: 'SIP',
    paymentStatus: 'Paid',
    amount: '₹ 5,000',
  },
  {
    id: 6,
    leadName: 'Arjun Sehgal',
    company: 'MAX',
    productInterest: 'Life Term',
    paymentStatus: 'Paid',
    amount: '₹ 5,000',
  },
  {
    id: 7,
    leadName: 'Virat Kumar',
    company: 'Aditya Birla',
    productInterest: 'Mutual Fund',
    paymentStatus: 'Paid',
    amount: '₹ 5,000',
  },
];

const InvoiceDetail = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 ">
    <div className=" mx-auto">
      {/* Header */}
      <div className="flex items-center gap-4 mb-8">
      <button className="p-2 border rounded-md" onClick={() => { navigate("/advisordetail") }}>
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="text-2xl font-semibold leading-7 text-blue-900">Invoice Detail</h1>
      </div>
      <div className='bg-white rounded-lg border p-4 flex flex-col border-gray-200 gap-5'>{/* Invoice Info */}
      <div className="bg-white rounded-lg    mb-8">
        <div className="grid grid-cols-3 gap-8">
          <div>
            <label className="block text-sm font-medium text-[#343A40] mb-2">Invoice No.</label>
            <div className="p-3  rounded-lg border text-gray-500">78964123</div>
          </div>
          <div>
            <label className="block text-sm font-medium text-[#343A40] mb-2">Name</label>
            <div className="p-3 rounded-lg border text-gray-500">Sidharth Malviya</div>
          </div>
          <div>
            <label className="block text-sm font-medium text-[#343A40] mb-2">Date</label>
            <div className="p-3 rounded-lg border text-gray-500">12 Feb 2025</div>
          </div>
        </div>
      </div>
      {/* Data Grid */}
      <div className="bg-white rounded-lg ">
        <CustomDataGrid
          columns={columns}
          rows={data}
          keyId="id"
          perPageSize={10}
          showPagination={false}
        />
        <div className="p-4  border-gray-200 flex justify-end">
          <div className="text-sm leading-4 font-semibold rounded-lg border p-4 text-[#2F4E74]">
            Total Amount : <span className="">₹35000</span>
          </div>
        </div>
      </div></div>
      
    </div>
  </div>
  )
}

export default InvoiceDetail

